
import React from 'react';
import cfg from '../../Config';

function OfferBox(){

    return (
        <div class="row gap-3 mt-4 align-items-start text-center mb-4">
            <div class="border rounded p-1 bg-body col-3 options-box mx-auto">
                <div className="p-3">
                    <img width="150" src="/images/offers/StonesCryOutCover.jpg" class="img-fluid rounded-top" alt="The Stones Cry Out: Biblical Archaeology, Prophecy, and the Last Days" />
                    <br />
                    <p className="text-gray fw-bold">
                        <small>$30 VALUE - <span className="text-red">FREE</span></small>
                    </p>
                </div>
                <div class="text-start head-line px-2">
                    <p className="fs-5 fw-bold mb-0">Get 'The Stones Cry Out' <br/> <span className="text-red">FREE</span> Offer With NEWSMAX+ <br /></p>
                    <p className="fs-6 mb-0">Sign up for Newsmax+ for a year <br/> and get Dinesh D'Souza's new book FREE - <br/> a $38 value with shipping!</p>
                    <p className="fs-7 fw-bold mt-2">
                        PLUS: Get Newsmax+
                        <br/>Just $39.99 for a year - <br/> a discount of $10 off the
                        <br/> annual price
                    </p>
                </div>
                <div class="text-gray text-justify top-box-border p-3">
                    <small>
                        Pay just $39.99 - get <strong>Newsmax+</strong> for a year and the free book - a savings of almost $50 in total value!
                    </small>
                    <br />
                    <br />
                    <small>
                        Cancel Newsmax+ at anytime for a full refund of the unused portion of your subscription and the book is yours to keep.
                    </small>
                </div>
            </div>
        </div>
    );
}

export const promotion = {
    offerId: cfg.promotions_offer.stones,
    OfferBox,
    shipping: {
        required: true,
        includePhone: true,
        requirePhone: false,
    },
    notEligible: {
        body: (<div className="mw-600 mx-auto">
            <h5 className="text-center text-red">You're Not Currently Eligible for This Offer</h5>
            <p className="text-center text-gray">But good news - you can still get the book for <strong>FREE</strong> with a subscription to <strong>Newsmax Magazine</strong>.</p>
            <p className="text-center text-gray">Get Dinesh D'Souza's book "The Stones Cry Out" <strong>FREE</strong> with our special offer.</p>
            <div className="d-flex justify-content-center">
                <a href="https://w3.newsmax.com/General/NMM/Offers/NMM-Renewal?dkt_nbr=071929amu9mx" className="nm-btn text-center rounded mx-auto mb-5">Click Here to Learn More!</a>
            </div>
            <p className="text-gray medium-text">
                <small>
                    <strong>Need help?</strong> If you have any questions or need assistance, please contact our support team by email or phone:
                    <ul className="medium-text">
                        <li>Our customer support email is <a className="text-gray fw-bold" href="mailto:customerservice@newsmax.com">customerservice@newsmax.com</a></li>
                        <li>Our customer support number is <a className="text-gray fw-bold" href="tel:+18004854350">1-800-485-4350</a>. Office hours are Mon-Fri 8:30am - 8:30pm ET and Sat 9:00am - 5:00pm ET.</li>
                    </ul>
                </small>
            </p>
        </div>)
    },
}
